import NotificationIcon from "src/images/Icons/newIcons/notifications/notification.svg";

import { htmlFormatter } from "../../../formatters/htmlFormatter";
import type { NotificationData } from "./List";
import { Notification } from "./NotificationItem";

interface InfoNotificationProps {
	notification: NotificationData;
	removeNotification: () => Promise<unknown>;
}

export function InfoNotification({
	notification,
	removeNotification,
}: InfoNotificationProps) {
	const redirect = async () => {
		if (notification.url) {
			window.location.href = notification.url;
		}
	};

	return (
		<Notification
			notification={notification}
			removeNotification={removeNotification}
			onRedirect={redirect}
			Icon={NotificationIcon}
			Primary={<div>{htmlFormatter(notification.message)}</div>}
			Secondary={null}
			disabledActionsList={["stopSubscribe"]}
		/>
	);
}
